import { foldCountryKey } from "./countryNames";
import { collectClientLookupContext } from "./clientLookupContext";

export function isTurkeyCountry(value) {
  const folded = foldCountryKey(value);
  if (!folded) return false;
  if (folded === "tr" || folded === "tur") return true;
  if (folded === "turkey" || folded === "turkiye") return true;
  if (folded.startsWith("turkey") || folded.startsWith("turkiye")) return true;
  return false;
}

export function getLicenseSoldCountry(license) {
  if (!license || typeof license !== "object") return "";
  return (
    license.assignedCountry ||
    license.usageCountry ||
    license.country ||
    license.soldCountry ||
    license.soldToCountry ||
    ""
  );
}

export function isLicenseSoldForTurkey(license) {
  return isTurkeyCountry(getLicenseSoldCountry(license));
}

export async function fetchClientGeoCountry() {
  const ctx = await collectClientLookupContext();
  return {
    country: ctx.country || "",
    countryCode: ctx.countryCode || ""
  };
}

export async function isClientInTurkey() {
  try {
    const geo = await fetchClientGeoCountry();
    return isTurkeyCountry(geo.countryCode) || isTurkeyCountry(geo.country);
  } catch {
    return false;
  }
}

/** True when a non-Turkey license is being used from a Turkey IP. */
export async function isForeignLicenseBlockedInTurkey(license) {
  if (!license) return false;
  if (isLicenseSoldForTurkey(license)) return false;
  return isClientInTurkey();
}
